import * as React from "react"
import { CPImageAlignment } from "../enums/CPImageAlignment"
import { CPImageSize } from "../enums/CPImageSize"
import { CPImage } from "../models/CPImage"

export interface ImageDisplayComponentProps {
    image: CPImage
    alignment: CPImageAlignment
    isForMobile: boolean
}

const ImageDisplayComponent = (props: ImageDisplayComponentProps) => {
    return (
        <>
            {props.alignment == props.image.align && !props.isForMobile && props.image.url && props.image.align == CPImageAlignment.Left ?
                    props.image.imageSize == CPImageSize.Small ?
                    <div className="col-6 col-md-3 col-lg-3 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                        :
                        props.image.imageSize == CPImageSize.Medium ?
                        <div className="col-6 col-md-4 col-lg-6 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                            :
                            props.image.imageSize == CPImageSize.Large ?
                            <div className="col-6 col-md-6 col-lg-6 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                                :
                                props.image.imageSize == CPImageSize.Default ?
                                <div className="col-6 col-md-4 col-lg-6 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                                    : ""
                    : ""
            }
            {props.alignment == props.image.align && !props.isForMobile && props.image.url && props.image.align == CPImageAlignment.Above ?
                props.image.imageSize == CPImageSize.Small ?
                    <div className="row"><div className="col-6 col-md-6 col-lg-4 offset-3 offset-md-3 offset-lg-4"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                    :
                    props.image.imageSize == CPImageSize.Medium ?
                        <div className="row"><div className="col-8 col-md-8 col-lg-6 offset-2 offset-md-2 offset-lg-3"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                        :
                        props.image.imageSize == CPImageSize.Large ?
                            <div className="row"><div className="col-12 col-md-12 col-lg-8 offset-lg-2"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                            :
                            props.image.imageSize == CPImageSize.Default ?
                                <div className="row"><div className="col-8 col-md-8 col-lg-6 offset-2 offset-md-2 offset-lg-3"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                                : ""
                : ""}
            {props.alignment == props.image.align && !props.isForMobile && props.image.url && props.image.align == CPImageAlignment.Right ?
                props.image.imageSize == CPImageSize.Small ?
                    <div className="col-6 col-md-3 col-lg-3 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                    :
                    props.image.imageSize == CPImageSize.Medium ?
                        <div className="col-6 col-md-4 col-lg-6 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                        :
                        props.image.imageSize == CPImageSize.Large ?
                            <div className="col-6 col-md-6 col-lg-6 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                            :
                            props.image.imageSize == CPImageSize.Default ?
                                <div className="col-6 col-md-4 col-lg-6 text-center"><img className="img-fluid cpproblemimage" src={props.image.url}></img></div>
                                : ""
                : ""}
            {props.alignment == props.image.align && !props.isForMobile && props.image.url && props.image.align == CPImageAlignment.Middle ?
                props.image.imageSize == CPImageSize.Small ?
                    <div className="row"><div className="col-6 col-md-6 col-lg-4 offset-3 offset-md-3 offset-lg-4"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                    :
                    props.image.imageSize == CPImageSize.Medium ?
                        <div className="row"><div className="col-8 col-md-8 col-lg-6 offset-2 offset-md-2 offset-lg-3"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                        :
                        props.image.imageSize == CPImageSize.Large ?
                            <div className="row"><div className="col-12 col-md-12 col-lg-8 offset-lg-2"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                            :
                            props.image.imageSize == CPImageSize.Default ?
                                <div className="row"><div className="col-8 col-md-8 col-lg-6 offset-2 offset-md-2 offset-lg-3"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                                : ""
                : ""}
            {/*props.alignment == props.image.align && props.isForMobile && props.image.url && (props.image.align == CPImageAlignment.Left || props.image.align == CPImageAlignment.Right) ?
                props.image.imageSize == CPImageSize.Small ?
                    <div className="row"><div className="col col-4 offset-4"><img className="d-lg-none mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                    :
                    props.image.imageSize == CPImageSize.Medium ?
                        <div className="row"><div className="col col-6 offset-3"><img className="d-lg-none mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                        :
                        props.image.imageSize == CPImageSize.Large ?
                            <div className="row"><div className="col col-8 offset-2"><img className="d-lg-none mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                            :
                            props.image.imageSize == CPImageSize.Default ?
                                <div className="row"><div className="col col-6 offset-3"><img className="d-lg-none mx-auto cpproblemimage" src={props.image.url}></img></div></div>
                                : ""
                : ""*/}
            {props.alignment == props.image.align && !props.isForMobile && props.image.url && props.image.align == CPImageAlignment.Below ?
                props.image.imageSize == CPImageSize.Small ?
                    <div className="col-6 col-md-6 col-lg-4 offset-3 offset-md-3 offset-lg-4"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div>
                    :
                    props.image.imageSize == CPImageSize.Medium ?
                        <div className="col-8 col-md-8 col-lg-6 offset-2 offset-md-2 offset-lg-3"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div>
                        :
                        props.image.imageSize == CPImageSize.Large ?
                            <div className="col-12 col-md-12 col-lg-8 offset-lg-2"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div>
                            :
                            props.image.imageSize == CPImageSize.Default ?
                                <div className="col-8 col-md-8 col-lg-6 offset-2 offset-md-2 offset-lg-3"><img className="mx-auto cpproblemimage" src={props.image.url}></img></div>
                                : ""
                : ""}
        </>
    )
}

export default ImageDisplayComponent